import { render } from "./BaseSignaturePad.vue?vue&type=template&id=5b9b9b2a&scoped=true"
import script from "./BaseSignaturePad.vue?vue&type=script&lang=js"
export * from "./BaseSignaturePad.vue?vue&type=script&lang=js"

import "./BaseSignaturePad.vue?vue&type=style&index=0&id=5b9b9b2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9b9b2a"]])

export default __exports__